import { Injectable, inject } from '@angular/core';
import { CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import {
  NOTICE_ISSUER_IMPORT_ROUTE,
  canAccessExecutionRoute,
  canAccessNoticeIssuerImportRoute,
  getPaymentAccessMode,
} from '../utils/payment-access.util';

@Injectable({ providedIn: 'root' })
export class ExecutionRouteGuard implements CanActivateChild {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  canActivateChild(_childRoute: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const groups = this.authService.currentUser()?.group;
    const targetUrl = state?.url ?? this.router.url ?? '';

    if (canAccessExecutionRoute(groups, targetUrl)) {
      return true;
    }

    if (getPaymentAccessMode(groups) === 'notice-only' && canAccessNoticeIssuerImportRoute(groups)) {
      return this.router.createUrlTree([NOTICE_ISSUER_IMPORT_ROUTE]);
    }

    return this.router.createUrlTree(['/pages-dashboard']);
  }
}
